export function formatSimilarityScore(value: unknown): string {
  if (value == null || value === '') return 'Not available';

  const raw = String(value).trim();
  if (!raw) return 'Not available';

  const numeric = Number(raw);
  if (Number.isNaN(numeric)) return 'Not available';

  const negative = raw.startsWith('-');
  const unsigned = negative ? raw.slice(1) : raw;
  const [intPart, fracPart = ''] = unsigned.split('.');
  const twoDecimals = fracPart.slice(0, 2).padEnd(2, '0');

  return `${negative ? '-' : ''}${intPart}.${twoDecimals}`;
}
